import { render, staticRenderFns } from "./DefaultHeaderDropdownSetting.vue?vue&type=template&id=323f9405&scoped=true"
import script from "./DefaultHeaderDropdownSetting.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdownSetting.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeaderDropdownSetting.vue?vue&type=style&index=0&id=323f9405&prod&lang=scss&scoped=true"
import style1 from "./DefaultHeaderDropdownSetting.vue?vue&type=style&index=1&id=323f9405&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f9405",
  null
  
)

export default component.exports